"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$supplProvisionHeadLine = exports.supplProvisionControl = exports.supplProvisionLabelPtn = void 0;
const factory_1 = __importDefault(require("../factory"));
const _indents_1 = __importDefault(require("./$indents"));
const line_1 = require("../../../node/cst/line");
const lexical_1 = require("./lexical");
const inline_1 = require("../../../node/cst/inline");
// eslint-disable-next-line no-irregular-whitespace
exports.supplProvisionLabelPtn = /^[附付][ 　\t\r\n]*則/;
exports.supplProvisionControl = ":suppl-provision:";
/**
 * The parser rule for {@link SupplProvisionHeadLine} that represents a head line of a supplementary provision. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/cst/rules/$supplProvisionHeadLine.spec.ts) for examples.
 */
exports.$supplProvisionHeadLine = factory_1.default
    .withName("supplProvisionHeadLine")
    .sequence(s => s
    .and(() => _indents_1.default, "indentsStruct")
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .and(r => r
    .sequence(s => s
    .and(r => r
    .choice(c => c
    .or(r => r.regExp(/^:keep-indents:/))
    .or(r => r.regExp(new RegExp(`^${exports.supplProvisionControl}`)))), "value")
    .action(({ value, range }) => ({ value, range: range() }))), "control")
    .and(r => r
    .sequence(s => s
    .and(() => lexical_1.$_, "value")
    .action(({ value, range }) => ({ value, range: range() }))), "trailingSpace")
    .action(({ control, trailingSpace }) => {
    return new inline_1.Control(control.value, control.range, trailingSpace.value, trailingSpace.range);
}))), "controls")
    .and(r => r
    .choice(c => c
    .orSequence(r => r
    .and(r => r.regExp(exports.supplProvisionLabelPtn), "text")
    .action(({ text, range }) => ({ text, range: range() })))
    .orSequence(s => s
    .andOmit(r => r.assert(({ controls }) => controls.some(c => c.control === exports.supplProvisionControl)))
    .and(r => r.regExp(/^[^(（\r\n]+/), "text")
    .action(({ text, range }) => ({ text, range: range() })))), "head")
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .asSlice(r => r
    .sequence(s => s
    .and(() => lexical_1.$_)
    .and(r => r.regExp(/^[(（]/)))), "openParen")
    .and(r => r.regExp(/^[^)）\r\n]+/), "amendLawNum")
    .and(r => r.regExp(/^[)）]/), "closeParen")
    .action(({ openParen, amendLawNum, closeParen }) => ({ openParen, amendLawNum, closeParen })))), "amendLawNumStruct")
    .and(r => r
    // eslint-disable-next-line no-irregular-whitespace
    .zeroOrOne(r => r.regExp(/^[ 　\t\r\n]*抄/)), "extract")
    .and(() => lexical_1.$_EOL, "lineEndText")
    .action(({ range, controls, indentsStruct, head, amendLawNumStruct, extract, lineEndText }) => {
    const errors = indentsStruct.errors;
    return {
        value: new line_1.SupplProvisionHeadLine({
            range: range(),
            indentTexts: indentsStruct.value.indentTexts,
            controls,
            title: head.text,
            titleRange: head.range,
            openParen: amendLawNumStruct?.openParen ?? "",
            amendLawNum: amendLawNumStruct?.amendLawNum ?? "",
            closeParen: amendLawNumStruct?.closeParen ?? "",
            extractText: extract ?? "",
            lineEndText,
        }),
        errors,
    };
}));
exports.default = exports.$supplProvisionHeadLine;
//# sourceMappingURL=$supplProvisionHeadLine.js.map